document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        var cartPage = document.querySelector('.woocommerce-cart');
        if (!cartPage) return;

        var products = document.querySelectorAll('.cart__product');
        var updateBasket = document.querySelector('.cart-actions__update');

        products.forEach(function (product) {
            var input = product.querySelector('.product__quantity-input');
            var plusBtn = product.querySelector('.product__plus');
            var minusBtn = product.querySelector('.product__minus');

            if (!input) return;

            // Create or get the error message element
            var errorMessage = input.nextElementSibling;
            if (!errorMessage || !errorMessage.classList.contains('product__quantity-error-message')) {
                errorMessage = document.createElement('span');
                errorMessage.classList.add('product__quantity-error-message');
                input.insertAdjacentElement('afterend', errorMessage);
            }

            // Shared validation function for this product
            function validateQuantity() {
                var inputValue = parseFloat(input.value);
                var maxValue = parseFloat(input.max);

                if (inputValue > maxValue) {
                    errorMessage.classList.add('product__quantity-error-message--active');
                    errorMessage.innerHTML = 'Only ' + maxValue + ' available. Need more? <a href="/contact/">Contact us</a>';


                    if (updateBasket) {
                        errorMessage.classList.add('product__quantity-error-message--cart');
                        updateBasket.disabled = true;
                        updateBasket.style.pointerEvents = 'none';
                        updateBasket.style.opacity = '0.5';
                        updateErrorMessageWidth();
                    }
                } else {
                    errorMessage.classList.remove('product__quantity-error-message--active');
                    errorMessage.textContent = '';

                    if (updateBasket) {
                        updateBasket.disabled = false;
                        updateBasket.style.pointerEvents = '';
                        updateBasket.style.opacity = '';
                    }
                }

                if (inputValue >= maxValue) {
                    if (plusBtn) plusBtn.disabled = true;
                } else {
                    if (plusBtn) plusBtn.disabled = false;
                }
            }

            function updateErrorMessageWidth() {
                if (window.innerWidth < 768) return;
                var quantityCell = product.querySelector('.cart__cell--quantity');
                if (quantityCell) {
                    var width = quantityCell.getBoundingClientRect().width - 10;
                    errorMessage.style.width = width + 'px';
                }
            }

            window.addEventListener('resize', function () {
                if (errorMessage.classList.contains('product__quantity-error-message--active')) {
                    updateErrorMessageWidth();
                }
            });

            // DOM Mutation Observer (applies to whole page — optional per product)
            var cartActionsContainer = document.querySelector('.cart-actions');
            if (cartActionsContainer) {
                var observer = new MutationObserver(function (mutationsList) {
                    for (var mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            validateQuantity();
                        }
                    }
                });

                observer.observe(cartActionsContainer, {
                    childList: true,
                    subtree: true
                });
            }

            // Input typing
            input.addEventListener('input', function () {
                this.setCustomValidity('');
                validateQuantity();
            });

            // Input validation fallback
            input.addEventListener('invalid', function () {
                var maxValue = parseFloat(this.max);
                this.setCustomValidity('Only ' + maxValue + ' available. Need more? Contact us');
            });

            // Plus/Minus buttons
            if (plusBtn) {
                plusBtn.addEventListener('click', function () {
                    setTimeout(validateQuantity, 0);
                });
            }

            if (minusBtn) {
                minusBtn.addEventListener('click', function () {
                    setTimeout(validateQuantity, 0);
                });
            }

            // Validate quantity once on page load
            validateQuantity();
        });
    }, 100);
});
